import { Edge as IEdge, EdgeId, NodeId, SocketId } from "./types";

export class Edge implements IEdge {
  id: EdgeId;
  source: {
    nodeId: NodeId;
    socketId: SocketId;
  };
  target: {
    nodeId: NodeId;
    socketId: SocketId;
  };
  metadata?: Record<string, unknown>;

  constructor(config: {
    id: EdgeId;
    source: {
      nodeId: NodeId;
      socketId: SocketId;
    };
    target: {
      nodeId: NodeId;
      socketId: SocketId;
    };
    metadata?: Record<string, unknown>;
  }) {
    this.id = config.id;
    this.source = config.source;
    this.target = config.target;
    this.metadata = config.metadata;
  }

  isConnectedTo(nodeId: NodeId): boolean {
    return this.source.nodeId === nodeId || this.target.nodeId === nodeId;
  }

  hasSocket(nodeId: NodeId, socketId: SocketId): boolean {
    return (
      (this.source.nodeId === nodeId && this.source.socketId === socketId) ||
      (this.target.nodeId === nodeId && this.target.socketId === socketId)
    );
  }

  toJSON(): IEdge {
    return {
      id: this.id,
      source: this.source,
      target: this.target,
      metadata: this.metadata,
    };
  }
}
